<template>
  <v-form
  class="mx-10 mb-10 pa-10 text-center"
    ref="form"
    v-model="valid"
    lazy-validation>

    <h3 class="text-left mb-5 text-primary">Generate CSR</h3>
    <v-layout>
      <v-flex md4>
        <v-select background-color="rgba(255,255,255)"
                  v-model="selectKeystore"
                  :items="keyStoreIdsList"
                  item-text="id"
                  item-value="id"
                  label="keyStoreId"
                  @change="changeKeystore"
                  outlined
                  dense
        ></v-select>
        <v-autocomplete background-color="rgba(255,255,255)"
                        v-model="selectProfile"
                        :items="profileOPTIONS"
                        item-text="friendlyName"
                        item-value="name"
                        label="Profile"
                        outlined
                        dense
        ></v-autocomplete>
        <v-autocomplete background-color="rgba(255,255,255)"
                        v-model="selectSecPolTmpl"
                        :items="secPolTmplOPTIONS"
                        label="SecPolTmpl"
                        outlined
                        dense
        ></v-autocomplete
        ><v-autocomplete background-color="rgba(255,255,255)"
                         v-model="csrKeySize"
                         :items="itemskeyOptions"
                         label="keyOptions"
                         outlined
                         dense
      ></v-autocomplete>
        <v-textarea 
        background-color="#999999"  
                    name="input-7-1"
                    label="Parameters"
                    class="mt-10"
                    no-resize
                    height="150px"
                    v-model="requestPayload"
                    outlined
        ></v-textarea>

      </v-flex>
      <v-flex md2>
        <v-btn
            :disabled="!valid"
            color="#007CA4"
            @click="validate"
            dark>
          Generate CSR >>
        </v-btn>
      </v-flex>
      <v-flex md6>
        <v-textarea
            background-color="rgba(255,255,255)"
            name="input-7-1"
            label="Response"
            no-resize
            height="550px"
            v-model="response"
            outlined
        ></v-textarea>
      </v-flex>
    </v-layout>
  </v-form>
</template>
<script>
import { mapMutations } from 'vuex'
import alisonJS from  '@/services/alison_js.js'
  export default {
    props:['keyStoreIds', 'keyStoreInfo', 'keyStoreId', 'data'],
    data: () => ({
      valid: true,
      keyStoreIdsList: [],
      csrKeySize: null,
      requestPayload: '{}',
      selectKeystore:"",
      selectSecPolTmpl:"",
      selectSecModPolTmpl:"",
      selectProfile: "",
      secPolTmplOPTIONS:[],
      profileOPTIONS:[],
      SecPolTmplValue:"{}",
      response: "",
      name: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      select: null,
      items: [
        'Item 1',
        'Item 2',
        'Item 3',
        'Item 4',
      ],
      itemskeyOptions: [
          '1024','2048','4096'
      ],
      checkbox: false,
    }),
    watch:{
      keyStoreId(){
        this.selectKeystore = this.keyStoreId;
      },
      keyStoreInfo(){
        this.profileOPTIONS.push({friendlyName: 'none', name:''})
        this.keyStoreInfo.forEach(elem => this.profileOPTIONS.push(elem))
      },
      selectSecPolTmpl(value) {
        this.updateRequest('securityPolicy',null,JSON.parse(value))
      },
      selectProfile(value){
        this.updateRequest('keyStore','profile',value)
      },
      csrKeySize(value){
        this.updateRequest('options','size',value)
      }
    },
    mounted(){
        if(this.keyStoreIds.length === 0) this.listKeystores()
        this.keyStoreIdsList = this.keyStoreIds.filter((key)=>key.capabilities.includes('G'));
        this.selectKeystore = this.keyStoreIdsList.find((key)=>key.id === this.keyStoreId) ? this.keyStoreId : null;
        if(this.selectKeystore){
          const keystore = this.keyStoreIdsList.filter((key)=>key.id === this.selectKeystore)[0];
          this.updateRequest('keyStore','id',this.selectKeystore)
          if(keystore.keyStoreType !== "TOKEN") this.profileOPTIONS.push({friendlyName: 'new profile', name:''})
        }
        this.keyStoreInfo.forEach(elem => this.profileOPTIONS.push(elem))
        let securityPolicyList = this.setSecurityPolicyOptions(this.selectKeystore)
        this.secPolTmplOPTIONS = this.objectToArray(this.data[securityPolicyList])
    },
    methods: {
      ...mapMutations({
        setSnack: 'setSnack',
        setColor: 'setColor'
      }),
      updateRequest(key1, key2, param){
        let request = JSON.parse(this.requestPayload)
        if(key2){
          if(!request[key1]) request[key1] = {}
          request[key1][key2] = param;
        }else{
          request[key1] = param;
        }
        this.requestPayload = JSON.stringify(request, null, "\t");
      },
      changeKeystore(){
        this.updateRequest('keyStore','id',this.selectKeystore)
        this.selectProfile = null
        let securityPolicyList = this.setSecurityPolicyOptions(this.selectKeystore)
        this.secPolTmplOPTIONS = this.objectToArray(this.data[securityPolicyList])
        this.getKeyStoreInfo(this.selectKeystore)
      },
      setSecurityPolicyOptions(keyStore) {
        let response
        switch (keyStore) {
          case "WIN-ENH":
            response = 'securityPolicyCAPI'
            break;

          case "CSK":
            response = 'securityPolicyCSK'
          break;

          case "PFX":
            response = 'securityPolicyPFX'
          break;
          
          case "MACOS" || "FF-NSS":
            response = 'securityPolicyEMPTY'
          break;

          default:
            response = 'securityPolicyDEVICE'
            break;
        }
        return response
      },
      
      objectToArray(objectValue){
        let newArray = []
        Object.keys(objectValue).forEach(element => {
          newArray.push({text: objectValue[element], value: element})
        });
        return newArray
      },
      validate () {
        if (this.$refs.form.validate()) {
          this.snackbar = true
          this.generateCsr()
        }
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      generateCsr(){
        alisonJS.generateCsr(JSON.parse(this.requestPayload)).then((csr)=>{
          this.response = JSON.stringify(csr, null , "\t")
          if(this.selectProfile == "") this.selectProfile = csr.profileName
          this.$emit('setConfig', 
          {
            keyStore: this.selectKeystore, 
            keyStoreIds: this.keyStoreIdsList,
            profile: this.selectProfile, 
            profileOPTIONS: this.profileOPTIONS,
            secPolTmplOPTIONS: this.secPolTmplOPTIONS,
            selectSecPolTmpl: this.selectSecPolTmpl
            })
            this.setColor('success')
            this.setSnack('Generated CSR')
            this.$emit('setCSR', csr.csr)
        }, (e) => {
          this.setColor('error')
          if(e.code && (e.detail || e.message)){
              if(e.message){ this.setSnack('ERROR ' + e.message) }
              else { this.setSnack('ERROR '+ e.code +': ' + e.detail) }
          }else{
            this.setSnack('FAILURE: ' + JSON.stringify(e))
          }
          this.response = JSON.stringify(e, null, "\t");
        })   
      },
      getKeyStoreInfo(keystoreId) {
        this.profileOPTIONS = []
          alisonJS.keyStoreInfo({id:keystoreId}).then((info) => {
            this.setColor('info')
              this.setSnack('KeyStore info obtained successfully')
              const keystore = this.keyStoreIdsList.filter((key)=>key.id === keystoreId)[0];
              if(keystore && keystore.keyStoreType !== "TOKEN") this.profileOPTIONS.push({friendlyName: 'new profile', name:''})
              info.keyStores.forEach(ks => {
                  this.profileOPTIONS = this.profileOPTIONS.concat(ks.profiles)
                });
          }).catch(e=>{
              this.setColor('error')
              this.setSnack('FAILURE: ' + JSON.stringify(e))
          })
      },
      listKeystores() {
        alisonJS.listKeyStores().then((list) => {
              this.keyStoreIdsList = list.keyStores.filter((key)=>key.capabilities.includes('G'));
              this.setColor('success')
              this.setSnack('KeyStores obtained successfully')
          }).catch((e)=>{
            console.log("error:", e)
            this.setColor('error')
            if(e.code && (e.detail || e.message)){
              if(e.message){ this.setSnack('ERROR ' + e.message) }
              else { this.setSnack('ERROR '+ e.code +': ' + e.detail) }
            }else{
              this.setSnack('FAILURE: ' + JSON.stringify(e))
            }
            this.response = JSON.stringify(e, null, "\t");
          })
      }
    },
  }
</script>